<div class="checkbox-container" [ngClass]="{'is-invalid':showInvalid}">

  <!-- Show a list with the names of the institutions checked -->
  <div class="selected-institutions row" *ngIf="checkedInstitutionIds.length > 0">
    <div class="selected-institution"
      *ngFor='let institutionId of checkedInstitutionIds'>
      <span class="institution-name-label">{{ getInstitutionName(institutionId) | labelSanitizer}}</span>
      <mat-icon (click)="checkOne(null, institutionId)">close</mat-icon>
    </div>
  </div>

  <div class="mr-3 bd-input search mt-4 d-flex justify-content-end">
    <input type="text" id="input" required="" inputSanitizer maxlength="100" class="" #modelSopTitle="ngModel"
      [ngClass]="searchText ? 'filled': '' " [(ngModel)]="searchText">
    <mat-icon class="search">search</mat-icon>
    <label for="input" class="label" [ngClass]="searchText ? 'filled': '' ">{{ 'INSTITUTION_MANAGEMENT.SEARCH' |
      translate}}</label>
    <button class="clean" (click)="cleanSearch()"><mat-icon>close</mat-icon></button>
    <div class="underline"></div>
  </div>

  <div class="checkbox-container-list">
    <div class="col-4 p-0 mb-2">
      <input type="checkbox" class="custom-control-input " id="selectAll" [(ngModel)]="selectAllChecked"
        (change)="checkAll($event)">
      <label for="selectAll">{{ 'INSTITUTION_MANAGEMENT.SELECT_ALL' | translate }}</label>
    </div>
    <div class="mb-2" *ngFor='let data of institutionList | search:searchText'>
      <ng-template [ngIf]="!data.institution.institution.isGroup">
        <input type="checkbox" class="custom-control-input"
          (change)="checkOne($event, data.institution.institution.institutionID)"
          [checked]="isChecked(data.institution.institution.institutionID)"
          id="customCheck-{{data.institution.institution.institutionID}}">
        <label
          for="customCheck-{{data.institution.institution.institutionID}}">{{data.institution.institution.institutionName
          | labelSanitizer}}</label>
      </ng-template>
    </div>
  </div>
</div>